jQuery($ => {
    class LocationSearch {
      constructor(element) {
        this._        = element;
        this._element = $(element);
        this._input   = this._element.find('.m-search__input');
        
        this._searchValue   = null;
        this._searchTimeout = false;
        this._searchRequest = false;

        this._suggestionsLocked = false;
        this._pickedValue       = null;
        this._isInteractingWithSuggestions = false;
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'location-search:init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        $(window).on('resize',     this.handleResize);
        this._element.on('search:clear',  this.handleClear);
        this._input.on('keyup',    this.handleKeyup);
        this._input.on('keydown',  this.handleKeydown);
        this._input.on('focus',    this.handleFocus);
        this._input.on('focusout', this.handleBlur);
        
        this._element.on('search:suggestion-picked', (_, text) => this.handleSuggestionPicked(text));
        this._element.on('search:position-found', this.cleanupSuggestions);
        this.setupSuggestionHandlers();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Stop Suggesting
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      stopSuggesting = (clearSuggestions = null) => {
        this._element.search('handleSuggestingOff');
        this._element.search('handleLoadingOff');
        this.cleanupSuggestions(clearSuggestions);
        if(this._searchTimeout) clearTimeout(this._searchTimeout);
        if(this._searchRequest) this._searchRequest.abort();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Start Suggesting
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      startSuggesting = () => {
        if (this._suggestionsLocked) return;

        this._searchRequest = $.post(AJAX.url, {
          action: 'location_search_suggestions',
          s: this._searchValue
        }).done(response => {
          if (this._suggestionsLocked) return;

          if (response.success) {
            this._element.search('handleSuggestingOn');
            this._element.find('.m-search__suggestions').remove();
            this._element.append(response.data);
            this._element.find('.m-suggestions__link--geo').geolocation_trigger();
            this._element.find('.m-search__suggestions').suggestions();
            this.setupSuggestionHandlers();
          }

          this._element.search('handleLoadingOff');
        })
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Cleanup Suggestions
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      cleanupSuggestions = (clearSuggestions = null) => {
        if (this._input.val().length === 0 || clearSuggestions) {
          if (this._element.find('.m-suggestions__item--geo')[0]) {
            this._element.find('.m-suggestions__item:not(.m-suggestions__item--geo)').remove();
          } else {
            this._element.find('.m-suggestions').remove();
          }
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Suggestion Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      setupSuggestionHandlers = () => {
        const $suggestions = this._element.find('.m-search__suggestions');
        
        $suggestions.on('mousedown touchstart', () => {
          this._isInteractingWithSuggestions = true;
        });
        
        $suggestions.on('mouseup touchend', () => {
          this._isInteractingWithSuggestions = false;
        });
        
        $suggestions.on('suggestions:keydown', (_, event) => {
          this.handleSuggestionKeydown(event);
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Resize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleResize = () => {
        if ( $(window).width() < 768 ) {
          this.stopSuggesting();
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Clear
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleClear = () => {
        this.stopSuggesting();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Focus
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleFocus = () => {
        if ( this._element.find('.m-search__suggestions')[0] ) {
          this._element.search('handleSuggestingOn');
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Blur
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      
      handleBlur = event => {
        if (this._isInteractingWithSuggestions) {
          return;
        }
        
        setTimeout(() => {
          const activeElement = document.activeElement;
          
          if (
            !activeElement ||
            (
              !$(activeElement).closest('.m-search')[0] &&
              !$(activeElement).is('.m-search')
            )
          ) {
            this.stopSuggesting();
          }
        }, 100);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Keyup
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleKeyup = (event) => {
        const currentValue = this._input.val();

        if (this._suggestionsLocked && currentValue === this._pickedValue) {
          return;
        }

        if (this._suggestionsLocked) {
          this._suggestionsLocked = false;
        }

        this._searchValue = currentValue;

        if ( this._searchTimeout ) clearTimeout(this._searchTimeout);
        if ( this._searchRequest ) this._searchRequest.abort();

        if(this._searchValue.length < 3) {
          if (event.key == 'Tab') return;

          return this.stopSuggesting();
        }

        if (event.key === 'Escape' || event.key === 'Esc') return this._element.search('handleSuggestingOff');

        if (event.key.includes('Arrow') || event.key === 'Enter') return;

        this._element.search('handleLoadingOn');
        this._searchTimeout = setTimeout(this.startSuggesting, 500);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleKeydown = event => {
        switch (event.key) {
          case "Escape":
          case "Esc":
            event.preventDefault();
            this.stopSuggesting();
            break;

          case 'Tab':
            if (!event.shiftKey) {
              this.stopSuggesting();
            }
            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Suggestion Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleSuggestionKeydown = event => {
        switch (event.key) {
          case "Escape":
          case "Esc":
            event.preventDefault();
            this.stopSuggesting(true);
            this._input.focus();
            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Suggestion Picked
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleSuggestionPicked = (text) => {
        this._suggestionsLocked = true;
        this._pickedValue       = text;

        this.stopSuggesting(true);
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.location_search = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].location_search = new LocationSearch(_[i], opt);
        else
          ret = _[i].location_search[opt].apply(_[i].location_search, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-location-search').location_search();
});